import React from 'react';

export default function Extracurricular() {
  return (
    <section
      id="extracurricular"
      data-aos="fade-up"
      className="py-20 px-6 bg-gray-50 text-gray-800 scroll-mt-24"
    >
      <div className="max-w-4xl mx-auto text-left transform transition-transform duration-300 hover:scale-[1.01] hover:shadow-xl rounded-lg p-6 hover:bg-white">
        <h2 className="text-3xl font-bold mb-6 transition-colors duration-300 hover:text-green-700 text-center">
          Extracurricular Activities
        </h2>

        <ul className="list-disc ml-6 space-y-4 text-lg transition-colors duration-300 hover:text-gray-700">
          {/* Sports Achievements */}
          <li className="transition-transform duration-200 hover:translate-x-2">
            🏹 <strong>First Place (Individual)</strong> – Indian Round, Kerala University Inter Collegiate (Inter Zone) Archery (Men) Championship, 2020–21.
          </li>
          <li className="transition-transform duration-200 hover:translate-x-2">
            🥈 <strong>Second Place (Team)</strong> – Indian Round, Kerala University Inter Collegiate (Inter Zone) Archery (Men) Championship, 2020–21.
          </li>
          <li className="transition-transform duration-200 hover:translate-x-2">
            🏐 <strong>Seventh Place</strong> – 34th Kerala State Inter-district Sub-Junior Volleyball Championship, 2011–12.
          </li>

          {/* General Extracurriculars */}
          <li className="transition-transform duration-200 hover:translate-x-2">
            📚 Volunteered for <strong>library literacy programs</strong> and workshops to promote reading habits among students and local communities.
          </li>
          <li className="transition-transform duration-200 hover:translate-x-2">
            🎨 Interests include <strong>graphic design, photography, and creative content writing</strong>.
          </li>
        </ul>
      </div>
    </section>
  );
}
